import { playerSettings } from '../GameKit/shared';
import GSObject from './Base/GSObject';

// The game wide settings for the player.
export default class PlayerSettings extends GSObject {
    constructor(parent) {
        super(parent);
        this.lives = playerSettings.livesDefault;
        this.bounce = playerSettings.bounceDefault;
        this.weight = playerSettings.weightDefault;
        this.texture = playerSettings.textureDefault;
        this.hue = playerSettings.textureHue;
        this.hat = playerSettings.hatDefault;
    }
}

PlayerSettings.serializeableFields = {
    lives: Number,
    bounce: Number,
    weight: Number,
    texture: String,
    hue: Number,
    hat: String
};
